define('widgets/donut/viewmodel',[
    'underscore',
    'knockout',
    'jquery'
], function(_, ko, $) {
    var Donut = function() {
        var self = this;
        self.progress = ko.observable(1);
        self.animate = false;
        self.responsive = false;
        self.speed = 0.4;
        self.maxPercentage = 100;
        self.isAnimating = ko.observable(false);
    };

    var DEFAULT_SETTINGS = {
        color: '#fff',
        thickness: 10,
        radius: 100
    };

    Donut.prototype.activate = function(settings) {
        var self = this;

        //Settings
        _.defaults(settings, DEFAULT_SETTINGS);
        self.radius = settings.radius;
        self.thickness = settings.thickness;
        self.color = settings.color;
        self.background = settings.background;
        self.travelling = settings.travelling;

        if (settings.animate) {
            self.animate = settings.animate;
        }
        if (settings.responsive) {
            self.responsive = settings.responsive;
        }
        if (settings.maxPercentage) {
            self.maxPercentage = settings.maxPercentage;
        }

        //Percentage
        self.percentage = settings.percentage;
        if (ko.isObservable(self.percentage)) {
            self.percentage.subscribe(function(newPercentage) {
                self.animatable.percentage(newPercentage);
            });
        }

        //Smooth variables that can animate
        self.animatable = {
            percentage: ko.observable(parseFloat(ko.unwrap(settings.percentage)))
        };

        //Thickness
        self.strokeWidth = self.thickness;

        //Size
        self.size = ko.deferredComputed(function() {
            var radius = ko.unwrap(self.radius),
                s = radius * 2,
                r = radius - (ko.unwrap(self.strokeWidth) / 2),
                d = r * 2,
                c = parseFloat(d * Math.PI).toFixed(1),
                size = self.responsive ? '100%' : s;
            return {
                r: r,
                d: d,
                c: c,
                w: size,
                h: size,
                cx: radius,
                cy: radius,
                viewBox: '0 0 ' + s + ' ' + s
            };
        });

        //Progress
        self.progress = ko.deferredComputed(function() {
            return (parseFloat(self.size().c) * (self.maxPercentage / 100)) * (parseFloat(self.animatable.percentage()) / 100);
        });

        //Stroke
        self.stroke = ko.deferredComputed(function() {
            var p = parseFloat(self.progress()).toFixed(1);
            var maxC = parseFloat(self.size().c * (self.maxPercentage / 100)).toFixed(1);
            return {
                dashArray: [p, self.size().c].join(' '),
                backgroundDashArray: [maxC, maxC].join(' ')
            };
        });
    };

    Donut.prototype.attached = function(view, parent) {
        $(parent).addClass('donut-wrapper');
    };

    return Donut;
});

